export enum ClientEconomicSectorType {
  Households = 'Households',
}
